//on change takeaway
export function init() {
    $(`select#location`).change(function () {
        $.proxy(takeaway());
    });

    $(`select#location`).parent().parent().parent().parent().find(`input`).first().change(function () {
        $.proxy(removeTakeaway(this));
    });
}

function takeaway() {
    let selected = false;
    let selectedInput = $(`select#location`).parent().parent().parent().parent().find(`input`).first();
    $(`select#location option`).each(function (index) {
        if (!selected) {
            if (index != 0) {
                selected = ($(this).prop(`selected`) == true) ? true : false;
            }
        }
    });
        if(selected) {
            selectedInput.prop("checked", true);
        }
}

function removeTakeaway(e) {
    if ($(e).prop(`checked`) == false) {
        $(`select#location option:first`).prop(`selected`, true)
    }

}
